













































































































import Pagination from "@/components/Pagination/index.vue"; // Secondary package based on el-pagination
import { Vue, Component } from "vue-property-decorator";
import path from "path";
import { deepClone } from "@/utils";
import { asyncRoutes } from "@/router";
import i18n from "@/lang";
import { RouteConfig } from "vue-router";
import {
  ResCode,
  PagingReq,
  MeterFault,
  Leakage,
  Company,
  MeterType,
  User,
} from "@/api/baseDefine";
import { ElTree, TreeData } from "element-ui/types/tree";
import { UserModule } from "@/store/modules/user";
import { ElStep } from "element-ui/types/step";
import {
  leakages,
  GetMessageReq,
  meterTypes,
  MeterTypeReq,
} from "../../api/meter";
import xlsx from "xlsx";
import { CompanyCommonReq, geCompanys } from "@/api/company";
import { queryUser, QueryUserReq } from "@/api/user";
/**
 * 包含所有功能的表单
 *
 * @export
 * @class ComplexTable
 * @extends {Vue}
 */
@Component({
  components: {
    Pagination,
  },
})
export default class Leakages extends Vue {
  private list: Leakage[] = [];
  private listLoading: boolean = true;
  private total = 0;
  private loading = false;
  private meterTypes: string[] = [];

  private isSearch = false;
  private getMessageReq: GetMessageReq = <GetMessageReq>{};
  private listQuery: GetMessageReq = <GetMessageReq>{
    page: 1,
    pageSize: 10,
  };
  public reset() {
    this.getMessageReq = <GetMessageReq>{};
  }

  public search() {
    this.isSearch = true;
    this.listQuery.page = 1;
    this.getList();
  }
  public onSelectUser(b) {
    if (b) {
      this.queryUser("");
    }
  }
  private queryUsers: User[] = [];
  public async queryUser(query) {
    if (query !== null && query !== undefined) {
      this.loading = true;
      const res = await queryUser(<QueryUserReq>{
        queryUserType: 0,
        query: query,
      });
      if (res.code === ResCode.SUCCESS) {
        this.queryUsers = res.data.users.list;
        this.loading = false;
      }
    }
  }

  private queryCompanys: Company[] = [];
  public onSelectCompany(b) {
    if (b) {
      this.queryCompany("");
    }
  }
  private queryMeterTypes: MeterType[] = [];
  public async queryMeterType() {
    this.loading = true;
    const res = await meterTypes(<MeterTypeReq>{});
    if (res.code === ResCode.SUCCESS) {
      this.queryMeterTypes = res.data.meterTypes.list;
      for (let type of this.queryMeterTypes) {
        type.name = this.meterTypes[type.id - 1];
      }
      this.loading = false;
    }
  }
  public async queryCompany(query) {
    let req: CompanyCommonReq = <CompanyCommonReq>{};
    let company: Company = <Company>{};
    req.page = 1;
    req.pageSize = 10;
    company.name = query;
    req.company = company;
    this.loading = true;
    const res = await geCompanys(req);
    if (res.code === ResCode.SUCCESS) {
      this.queryCompanys = res.data.companys.list;
      this.loading = false;
    }
  }
  public async getList() {
    this.listLoading = true;
    let req: GetMessageReq = <GetMessageReq>{};
    if (this.isSearch) {
      req = this.getMessageReq;
      req.page = this.listQuery.page;
      req.pageSize = this.listQuery.pageSize;
    } else {
      req = this.listQuery;
    }
    const res = await leakages(req);
    if (res.code === ResCode.SUCCESS) {
      this.list = res.data.leakageData.list;
      this.total = res.data.leakageData.totalCount;
    }
    this.listLoading = false;
  }
  public async exportExecl() {
    let json = await this.getAllData();
    let ss = xlsx.utils.json_to_sheet(json, null); //通过工具将json转表对象
    let keys = Object.keys(ss).sort(); //排序 [需要注意，必须从A1开始]
    let ref = keys[1] + ":" + keys[keys.length - 1]; //这个是定义一个字符串 也就是表的范围[A1:C5]
    let workbook = {
      //定义操作文档
      SheetNames: ["nodejs-sheetname"], //定义表明
      Sheets: {
        "nodejs-sheetname": ss, //表对象[注意表明]
      },
    };
    xlsx.writeFile(
      workbook,
      "leakages" + Math.floor(Date.now() / 1000) + ".xls",
      null
    ); //将数据写入文件
  }
  public async getAllData(): Promise<Leakage[]> {
    let pageSize = 100;
    let page = 1;
    let reqs: GetMessageReq[] = [];
    let promises: Promise<Leakage[]>[] = [];
    let maxPage = Math.ceil(this.total / pageSize);
    let lists: Leakage[] = [];
    while (maxPage - page >= 0) {
      let req: GetMessageReq = <GetMessageReq>{};
      req.page = page;
      req.pageSize = pageSize;
      let promise = this.getListForAllData(req);
      promises.push(promise);
      page++;
    }
    let listss = await Promise.all(promises);
    for (let list of listss) {
      lists = lists.concat(list);
    }
    return lists;
  }

  public async getListForAllData(req: GetMessageReq): Promise<Leakage[]> {
    let self = this;
    return new Promise<Leakage[]>(function (value, rej) {
      if (self.isSearch) {
        req.meterTypeID = self.meterTypes.indexOf(req.meterTypeName) + 1;
      }
      leakages(req)
        .then(function (res) {
          if (!!res && res.code === ResCode.SUCCESS) {
            let list = res.data.leakageData.list;
            value(list);
          }
        })
        .catch(function (reason) {
          rej(reason);
        });
    });
  }
  private created() {
    this.meterTypes = [
      this.$t("meterTypes.water").toString(),
      this.$t("meterTypes.power").toString(),
      this.$t("meterTypes.gas").toString(),
      this.$t("meterTypes.hot").toString(),
      this.$t("meterTypes.pv").toString(),
    ];
    this.queryMeterType();
    this.getList();
  }
}
